import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
import {modals, permissions, sdoNs} from '../constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';
import SessionActions from '../session-sdo';
import '../sdo-user-jobs';
import './sdo';
import {hasOneOfPermissions} from '@modules/permissions';
import {ApiService} from '@modules/api-service';
import {SimpleModal} from '@modules/simple-modal';
import '@modules/print-reports-modal';
/**
 * @summary SiteHeader
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('site-navigation')
class SiteNavigation extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of SiteHeader.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static get is() {
    return 'site-navigation';
  }

  @property({type: Boolean, mapState: `${sdoNs.DASHBOARD}.$atClassLevel`, store: storeInstance})
  atClassLevel = false;

  @property({type: Array, attribute: false, mapState: `${sdoNs.SESSION}.$activeAoflProducts`, store: storeInstance})
  products = [];

  @property({type: Object, attribute: false, mapState: `${sdoNs.SESSION}.$myGroups`, store: storeInstance})
  myGroups = {};

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.loggedIn`, store: storeInstance})
  loggedIn = false;

  @property({type: String, mapState: `${sdoNs.SESSION}.type`, store: storeInstance})
  userType = '';

  @property({type: Array, attribute: false, mapState: `${sdoNs.LEFT_MENU}.$menuItems`, store: storeInstance})
  menuItems = [];

  @property({type: Array, attribute: false, mapState: `${sdoNs.SESSION}.group_info.level`, store: storeInstance})
  myLevel = '0';

  @property({type: String, mapState: `${sdoNs.DASHBOARD}.pendingFilters.stats_path`, store: storeInstance})
  statsPath;

  @property({type: Array, attribute: false, mapState: `${sdoNs.SESSION}.settings.feature_flags`, store: storeInstance})
  featureFlags = [];

  @property({type: Object, attribute: false, mapState: `${sdoNs.SESSION}.settings`, store: storeInstance})
  settings = {};

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.$isRootAdmin`, store: storeInstance})
  isRootAdmin;

  @property({
    type: Number,
    mapState: `${sdoNs.SESSION}.group_info.id`,
    store: storeInstance,
    hasChanged: async (newVal, oldVal) => {
      if (newVal !== oldVal) {
        if (newVal) {
          const queryObj = {
            filters: {
              group_id: newVal
            },
            sort: {
              limit: 2,
              is_forward: true,
              fields: ['timestamp', 'id'],
            },
          };
          if (!hasOneOfPermissions([permissions.SPONSOR, permissions.HIDE_STUDENT])) {
            const resp = await ApiService.inventoryUpdatesLogSearch(queryObj);
            storeInstance.commit({
              namespace: sdoNs.INVENTORY_UPDATE_LOG,
              mutationId: 'setData',
              payload: resp
            });
          }
        }
        return true;
      }
      return false;
    },
  })
  groupId = null;

  openReportDownloadModal(e) {
    SimpleModal.show(modals.RESOURCE_PRINT_REPORT, {}, e);
  }

  logout() {
    setTimeout(() => {
      SessionActions.logout();
    }, 150); /** @todo temporary hack - wait for drawer to close */
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default SiteNavigation;

